export const contactInformationFormValidator = values => {
  const errors = {}
  // If the user has entered anything for secondary phone number or secondary phone number type code
  if (values.primaryPhoneNumber && !values.primaryPhoneNumberType) {
    errors.primaryPhoneNumberType = 'Required'
  }
  if (values.primaryPhoneNumberType && values.primaryPhoneNumberType !== '- Select -' && !values.primaryPhoneNumber) {
    errors.secondaryPhoneNumber = 'Required'
  }
  if (values.primaryPhoneNumberExtension && !values.primaryPhoneNumber) {
    errors.primaryPhoneNumber = 'Required'
  }
  if (values.primaryPhoneNumberExtension && !values.primaryPhoneNumberType) {
    errors.primaryPhoneNumberType = 'Required'
  }
  if (values.secondaryPhoneNumber && !values.secondaryPhoneNumberType) {
    errors.secondaryPhoneNumberType = 'Required'
  }
  if (values.secondaryPhoneNumberType && values.secondaryPhoneNumberType !== '- Select -' && !values.secondaryPhoneNumber) {
    errors.secondaryPhoneNumber = 'Required'
  }
  if (values.secondaryPhoneNumberExtension && !values.secondaryPhoneNumber) {
    errors.secondaryPhoneNumber = 'Required'
  }
  if (values.secondaryPhoneNumberExtension && !values.secondaryPhoneNumberType) {
    errors.secondaryPhoneNumberType = 'Required'
  }

  if (Object.getOwnPropertyNames(errors).length > 0) {
    console.error('Errors in ContactInformationForm', errors)
  } else {
    console.log('No validation errors in ContactInformationForm')
  }

  return errors

}